import { message, Space, Form as FormInitial, Row, Col } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
  ErrorItem,
} from "../../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import entregarInsumosPdf from "../../../../../Pdf/entregarInsumosPdf";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

class EnviarCorreoEntregarInsumosVenta extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    pdf: null,
  };

  componentDidMount() {
    if (this.props.visible && this.props.entregaId) {
      this.consultarTodo();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible && this.props.id) {
      this.consultarTodo();
    } else if (this.props.visible && this.props.entregaId !== prevProps.entregaId && this.props.entregaId) {
      this.consultarTodo();
    }
  }

  consultarTodo() {
    this.setState({ loading: true });

    axios
      .post(
        "ventas/datosEntregaPdf",
        { 
          ventaId: this.props.id, 
          empresaId: this.props.empresaId, 
          entregaId: this.props.entregaId,
          padre: this.props.padre || 1
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        
        if (res.data.success === 2) {
          if (res.data?.correosEnvio?.length > 0 && this.formRef.current) {
            this.formRef.current.setFieldsValue({ correosEnvio: res.data.correosEnvio });
          }
          
          const dd = entregarInsumosPdf(res.data); 
          const pdfDoc = pdfMake.createPdf(dd);
          
          this.setState(
            {
              loading: false,
              pdf: pdfDoc,
              factura: res.data.factura,
            },
            () => {
              pdfDoc.open({}, window.frames["entregaPdf"]); 
            }
          );
        } else {
          this.setState({ loading: false });
          message.error("No se pudieron cargar los datos de la entrega");
        }
      })
      .catch((err) => {
        console.error("Error en consultarTodo:", err);
        this.setState({ loading: false });
        message.error("Error al cargar los datos de la entrega");
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    if (values?.correosEnvio?.length > 0) {
      this.setState({ loading: true });
      axios
        .post(
          "ventas/enviarEnvioEntrega",
          { 
            ...values, 
            ventaId: this.props.id, 
            empresaId: this.props.empresaId,
            entregaId: this.props.entregaId
          },
          {
            headers: this.props.headersToken,
          }
        )
        .then((res) => {
          this.setState({ loading: false });
          if (res.data.success === 2) {
            message.success("Entrega Enviada");
            this.formRef.current.resetFields();
            this.cerrarMandarCorreo();
          } else if (res.data.success === 1) {
            message.error("No se pudo enviar la entrega");
          } else {
            message.error("Sucedió un error y no se pudo enviar");
          }
        })
        .catch((err) => {
          console.error("Error al enviar correo:", err);
          this.setState({ loading: false });
          message.error("Error al enviar el correo");
        });
    } else {
      message.info('Proporcione al menos un correo de envío');
    }
  }

  cerrarMandarCorreo() {
    this.props.cerrarMandarCorreo();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  }

  render() {
    return (
      <ModalItem
        title="Vista previa"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarMandarCorreo.bind(this)}
        paddingTop
        zIndex={this.props.zIndex}
      >
        <Form
          ref={this.formRef}
          name="mandarCorreo"
          layout
          width={700}
          onCancel={this.cerrarMandarCorreo.bind(this)}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormInitial.List
            name="correosEnvio"
            initialValue={[{ correo: '' }]}
          >
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ name }, arrayKey) => (
                  <Row key={name}>
                    <Col span={22}>
                      <FormItem
                        name={[name, "correo"]}
                        fieldKey={[arrayKey, "correo"]}
                        label='Correo'
                        required
                        margin
                        email
                        pattern
                      >
                        <InputItem style={{ width: '100%' }} placeholder="Correo" />
                      </FormItem>
                    </Col>
                    <Col span={2}>
                      <div style={{ textAlign: 'center' }}>
                        <MinusCircleOutlined
                          onClick={() => remove(name)}
                        />
                      </div>
                    </Col>
                  </Row>
                ))}
                {fields.length < 5 ?
                  <div style={{ textAlign: 'center', marginTop: '5px' }}>
                    <ButtonItem
                      type="primary"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      Agregar
                    </ButtonItem>
                  </div>
                  : null}
              </>
            )}
          </FormInitial.List>
          <div style={{ display: "flex", justifyContent: "right", marginTop: 20, marginBottom: 10 }}>
            <Space>
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Mandar Correo
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                onClick={this.cerrarMandarCorreo.bind(this)}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cancelar
              </ButtonItem>
            </Space>
          </div>
        </Form>
        <iframe
          title={"Entregar Insumos"}
          style={{ width: "100%", height: "100vh" }}
          id="entregaPdf"
          name="entregaPdf"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(EnviarCorreoEntregarInsumosVenta);